'use strict';

function init() {
	if (!document.getElementsByClassName('__keyDates').length)
		return

	var toggles = document.querySelectorAll('.conferenceInstance__toggle');
	var trays = document.querySelectorAll('.conferenceInstance__items');

	if (toggles.length > 0){
		trays.forEach(function(element){
			element.classList.add('js-ready');
		});
	}

	toggles.forEach(function(element, index) {
		element.addEventListener('click', function(event) {
			event.preventDefault();

			trays[index].classList.toggle('conferenceInstance__items--active');
			element.classList.toggle('conferenceInstance__toggle--active');
		});
	});
}

module.exports = {
	init: init
}
